// Andobrée — product catalog. One product per color.

export const products = [
  // ====== BIKINI TOPS ======
  {
    id: 'bikini-top-black',
    name: 'Andobrée Bikini Top — Black',
    price: 22,
    category: 'swimwear',
    collection: 'for_everyone',
    image: '/items/bikini-top-black.jpg',
    images: ['/items/bikini-top-black.jpg'],
    description:
      'A signature triangle bikini top in soft stretch jersey, finished with adjustable halter ties and woven Andobrée labels on each cup.',
    details: 'Recycled nylon / elastane jersey. Hand wash cold, lay flat to dry. Made in atelier.',
    sizes: ['XS', 'S', 'M', 'L', 'XL'],
    color: 'Black',
  },
  {
    id: 'bikini-top-blue',
    name: 'Andobrée Bikini Top — Blue',
    price: 22,
    category: 'swimwear',
    collection: 'for_everyone',
    image: '/items/bikini-top-blue.jpg',
    images: [
      '/items/bikini-top-blue.jpg',
      '/items/bikini-top-blue-angle-1.jpg',
      '/items/bikini-top-blue-angle-2.jpg',
      '/items/bikini-top-blue-angle-3.jpg',
      '/items/bikini-top-blue-angle-4.jpg',
    ],
    description:
      'A signature triangle bikini top in soft stretch jersey, finished with adjustable halter ties and woven Andobrée labels on each cup.',
    details: 'Recycled nylon / elastane jersey. Hand wash cold, lay flat to dry. Made in atelier.',
    sizes: ['XS', 'S', 'M', 'L', 'XL'],
    color: 'Blue',
  },

  // ====== BIKINI BOTTOMS ======
  {
    id: 'bikini-bottom-black',
    name: 'Andobrée Bikini Bottom — Black',
    price: 22,
    category: 'swimwear',
    collection: 'for_everyone',
    image: '/items/bikini-bottom-black-front.jpg',
    images: ['/items/bikini-bottom-black-front.jpg'],
    description:
      'High-cut ribbed bikini bottom with a flattering V-front and signature Andobrée label.',
    details: 'Recycled nylon / elastane rib. Hand wash cold, lay flat to dry. Made in atelier.',
    sizes: ['XS', 'S', 'M', 'L', 'XL'],
    color: 'Black',
  },
  {
    id: 'bikini-bottom-blue',
    name: 'Andobrée Bikini Bottom — Blue',
    price: 22,
    category: 'swimwear',
    collection: 'for_everyone',
    image: '/items/bikini-bottom-blue-front.jpg',
    images: ['/items/bikini-bottom-blue-front.jpg'],
    description:
      'High-cut ribbed bikini bottom with a flattering V-front and signature Andobrée label.',
    details: 'Recycled nylon / elastane rib. Hand wash cold, lay flat to dry. Made in atelier.',
    sizes: ['XS', 'S', 'M', 'L', 'XL'],
    color: 'Blue',
  },

  // ====== JEANS / PANTS ======
  {
    id: 'rose-jeans',
    name: 'Andobrée Rose Jeans',
    price: 150,
    originalPrice: 300,
    category: 'bottoms',
    collection: 'for_everyone',
    image: '/items/rose-jeans-front.jpg',
    images: [
      '/items/rose-jeans-front.jpg',
      '/items/rose-jeans-back.jpg',
      '/items/rose-jeans-angle-1.jpg',
      '/items/rose-jeans-angle-2.jpg',
      '/items/rose-jeans-angle-3.jpg',
      '/items/rose-jeans-angle-4.jpg',
    ],
    description:
      'Reconstructed dark denim layered with vintage rose tapestry panels, raw-edge patchwork and hand-stitched lace ribbon.',
    details: 'Reworked cotton denim with cotton floral fabric and lace trim. Spot clean only. Made in atelier.',
    sizes: ['XS', 'S', 'M', 'L', 'XL'],
    color: 'Rose / Indigo',
    onSale: true,
  },
  {
    id: 'west-jeans',
    name: 'Andobrée West Side Jeans',
    price: 120,
    category: 'bottoms',
    collection: 'for_everyone',
    image: '/items/west-jeans-front.jpg',
    images: [
      '/items/west-jeans-front.jpg',
      '/items/west-jeans-back.jpg',
      '/items/west-jeans-angle-1.jpg',
      '/items/west-jeans-angle-2.jpg',
      '/items/west-jeans-angle-3.jpg',
      '/items/west-jeans-angle-4.jpg',
    ],
    description:
      'Patchworked indigo denim built up with blue checkered cotton, raw cream canvas inserts and crochet lace trim.',
    details: 'Reworked cotton denim with cotton plaid panels and lace trim. Spot clean only. Made in atelier.',
    sizes: ['XS', 'S', 'M', 'L', 'XL'],
    color: 'Indigo / Cream',
  },
  {
    id: 'pink-jeans',
    name: 'Andobrée Pink Jeans',
    price: 160,
    category: 'bottoms',
    collection: 'for_everyone',
    image: '/items/pink-jeans-front.jpg',
    images: [
      '/items/pink-jeans-front.jpg',
      '/items/pink-jeans-back.jpg',
      '/items/pink-jeans-angle-1.jpg',
      '/items/pink-jeans-angle-2.jpg',
      '/items/pink-jeans-angle-3.jpg',
      '/items/pink-jeans-angle-4.jpg',
    ],
    description:
      'Indigo denim base layered with monochrome plaid side panels, soft pink cotton inserts and ivory lace ribbon.',
    details: 'Reworked cotton denim with cotton plaid and lace trim. Spot clean only. Made in atelier.',
    sizes: ['XS', 'S', 'M', 'L', 'XL'],
    color: 'Pink / Indigo',
  },
  {
    id: 'summer-pants-red',
    name: 'Andobrée Summer Pants — Red',
    price: 70,
    category: 'bottoms',
    collection: 'for_everyone',
    image: '/items/summer-pants-red-front.jpg',
    images: [
      '/items/summer-pants-red-front.jpg',
      '/items/summer-pants-red-back.jpg',
      '/items/summer-pants-red-angle-1.jpg',
      '/items/summer-pants-red-angle-2.jpg',
      '/items/summer-pants-red-angle-3.jpg',
      '/items/summer-pants-red-angle-4.jpg',
    ],
    description:
      'Lightweight red gingham cotton-blend pants with an elastic waist and breezy wide-leg drape.',
    details: 'Cotton-blend gingham. Machine wash cold, line dry. Made in atelier.',
    sizes: ['XS', 'S', 'M', 'L', 'XL'],
    color: 'Red',
  },
  {
    id: 'summer-pants-blue',
    name: 'Andobrée Summer Pants — Blue',
    price: 70,
    category: 'bottoms',
    collection: 'for_everyone',
    image: '/items/summer-pants-blue-front.jpg',
    images: ['/items/summer-pants-blue-front.jpg', '/items/summer-pants-blue-back.jpg'],
    description:
      'Lightweight blue gingham cotton-blend pants with an elastic waist and breezy wide-leg drape.',
    details: 'Cotton-blend gingham. Machine wash cold, line dry. Made in atelier.',
    sizes: ['XS', 'S', 'M', 'L', 'XL'],
    color: 'Blue',
  },

  // ====== BAGS ======
  {
    id: 'bag-black',
    name: 'Andobrée Bag — Black',
    price: 90,
    category: 'bags',
    collection: 'essentials',
    image: '/items/bag-black.jpg',
    images: ['/items/bag-black.jpg'],
    description:
      'An oversized diamond-quilted tote in a featherlight padded shell, finished with slim leather-look top handles and a woven Andobrée label.',
    details: 'Quilted recycled nylon shell, faux-leather handles, interior pocket. Spot clean only.',
    sizes: ['One Size'],
    color: 'Black',
  },
  {
    id: 'bag-white',
    name: 'Andobrée Bag — White',
    price: 90,
    category: 'bags',
    collection: 'essentials',
    image: '/items/bag-white.jpg',
    images: ['/items/bag-white.jpg'],
    description:
      'An oversized diamond-quilted tote in a featherlight padded shell, finished with slim leather-look top handles and a woven Andobrée label.',
    details: 'Quilted recycled nylon shell, faux-leather handles, interior pocket. Spot clean only.',
    sizes: ['One Size'],
    color: 'White',
  },
  {
    id: 'clutch-white',
    name: 'Andobrée Clutch Bag — White',
    price: 70,
    category: 'bags',
    collection: 'essentials',
    image: '/items/clutch-white.jpg',
    images: ['/items/clutch-white.jpg'],
    description:
      'A softly puffed clutch in diamond-quilted nylon, finished with a sleek leather strap and zip closure.',
    details: 'Quilted recycled nylon, smooth leather strap, zip closure. Spot clean only.',
    sizes: ['One Size'],
    color: 'White',
  },
  {
    id: 'clutch-green',
    name: 'Andobrée Clutch Bag — Green',
    price: 70,
    category: 'bags',
    collection: 'essentials',
    image: '/items/clutch-green.jpg',
    images: ['/items/clutch-green.jpg'],
    description:
      'A softly puffed clutch in diamond-quilted nylon, finished with a sleek leather strap and zip closure.',
    details: 'Quilted recycled nylon, smooth leather strap, zip closure. Spot clean only.',
    sizes: ['One Size'],
    color: 'Green',
  },
  {
    id: 'purse',
    name: 'Andobrée Purse',
    price: 45,
    category: 'bags',
    collection: 'essentials',
    image: '/items/purse.jpg',
    images: ['/items/purse.jpg'],
    description:
      'A glossy quilted top-handle purse in deep navy nylon, finished with a single arched handle and a discreet metal stud.',
    details: 'Quilted nylon shell, fabric lining, magnetic snap closure. Spot clean only.',
    sizes: ['One Size'],
    color: 'Navy',
  },
];

export const collections = [
  {
    id: 'for_everyone',
    name: 'For Everyone',
    tagline: 'A celebration of every body, every story',
    image: '/foreveryone/main.jpg',
    heroImage: '/items/fe-hero.jpg',
    lookbook: true,
  },
];

// Lookbook images for the "For Everyone" collection page.
// The 4th image of the first row has been removed per request.
export const forEveryoneLookbook = [
  '/foreveryone/0.jpeg',
  '/foreveryone/1.jpeg',
  '/foreveryone/2.jpeg',
  // (4th removed)
  '/foreveryone/4.jpeg',
  '/foreveryone/5.jpeg',
  '/foreveryone/6.jpeg',
  '/foreveryone/7.jpeg',
  '/foreveryone/8.jpeg',
  '/foreveryone/9.jpeg',
  '/foreveryone/10.jpeg',
  '/foreveryone/11.jpeg',
  '/foreveryone/12.jpeg',
  '/foreveryone/13.jpg',
  '/foreveryone/14.jpeg',
  '/foreveryone/15.jpeg',
  '/foreveryone/16.jpeg',
  '/foreveryone/17.jpeg',
];

export const heroData = {
  eyebrow: 'For Everyone Collection',
  title: 'Be Unique With Us.',
  cta: 'Discover the Collection',
  image: `/hero_extended.png`,
};

export const editorialImage = '/items/fe-hero.jpg';
export const philosophyQuote = 'Fashion is for everyone.';
